import axiosInstance from "./axiosInstance";

//電話國碼
export const country_tel = (data) => axiosInstance.post("/auth/country_tel", data);

// 註冊
export const registerUser = (data) => axiosInstance.post("/auth/register", data);

// 驗證 Email（註冊用）
export const verifyEmail = (data) => axiosInstance.post("/auth/verify-email", data);

// 重發驗證碼
export const resendVerificationCode = (data) => axiosInstance.post("/auth/resend-verification", data);